export default __webpack_public_path__ + "static/2010_2020-531c3e79bbbd2096356340a050958ae4.jpg";